'use client'

import Link from 'next/link'
import { useEffect } from 'react'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Stephen 2026-06-18: log full error to console so DevTools resolves
    // the stack via productionBrowserSourceMaps (now enabled in
    // next.config.js). The trace tells us which `.startsWith` site is
    // actually crashing post-tmp-bug-fix + PR #878.
    // eslint-disable-next-line no-console
    console.error('[client-error]', {
      message: error.message,
      digest: error.digest,
      stack: error.stack,
      name: error.name,
    })
  }, [error])

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="text-center space-y-4 max-w-2xl">
        <h1 className="text-2xl font-semibold text-atrium-black">Something went wrong</h1>
        {error.message && (
          <p className="text-sm text-atrium-muted">{error.message}</p>
        )}
        {error.digest && (
          <p className="text-xs text-atrium-muted">Error digest: <code>{error.digest}</code></p>
        )}
        {error.stack && (
          <details className="text-left bg-atrium-surface-muted/40 rounded-lg p-3 text-xs">
            <summary className="cursor-pointer text-atrium-muted">Stack trace</summary>
            <pre className="mt-2 overflow-x-auto whitespace-pre-wrap break-words text-[10px] leading-tight text-atrium-muted">
              {error.stack}
            </pre>
          </details>
        )}
        <div className="flex items-center justify-center gap-4 pt-2">
          <button
            onClick={reset}
            className="px-4 py-2 bg-accent-600 hover:bg-accent-700 text-white text-sm font-medium rounded-lg transition-colors"
          >
            Try again
          </button>
          <Link
            href="/"
            className="text-sm text-atrium-muted hover:text-atrium-black transition-colors"
          >
            Go home
          </Link>
        </div>
      </div>
    </div>
  )
}
